// Google Analytics (GA4) + optional GTM — baked in at build time, guarded so an
// empty id is a no-op. Also exposes a tiny track() helper for funnel events.

let ready = false;

export function initAnalytics() {
  const ga = __GA4_MEASUREMENT_ID__;
  const gtm = __GTM_CONTAINER_ID__;

  if (gtm) {
    // Google Tag Manager
    (function () {
      const s = document.createElement('script');
      s.async = true;
      s.src = `https://www.googletagmanager.com/gtm.js?id=${gtm}`;
      document.head.appendChild(s);
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ 'gtm.start': Date.now(), event: 'gtm.js' });
    })();
  }

  if (ga) {
    const s = document.createElement('script');
    s.async = true;
    s.src = `https://www.googletagmanager.com/gtag/js?id=${ga}`;
    document.head.appendChild(s);
    window.dataLayer = window.dataLayer || [];
    window.gtag = function gtag() {
      // eslint-disable-next-line prefer-rest-params
      window.dataLayer!.push(arguments);
    };
    window.gtag('js', new Date());
    window.gtag('config', ga, { anonymize_ip: true });
    ready = true;
  }
}

export function track(event: string, params: Record<string, unknown> = {}) {
  try {
    if (ready && window.gtag) window.gtag('event', event, params);
    if (window.dataLayer) window.dataLayer.push({ event, ...params });
  } catch {
    /* no-op */
  }
}
